/**
 * Shared helper for "Log out of all devices" (R0-2).
 * Kept small and importable so App.js and tests share one behaviour.
 */
export async function logoutAllDevicesAction({
  apiUrl,
  token,
  fetchImpl = fetch,
  logout,
}) {
  const current = (typeof localStorage !== 'undefined' && localStorage.getItem('token')) || token;
  try {
    if (current) {
      await fetchImpl(`${apiUrl}/api/auth/logout-all`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${current}` },
      });
    }
  } catch {
    /* still clear local session */
  }
  logout();
}
